if(!window._bsWagen){window._bsWagen=1;
let CLU=null,SE=null;try{const m=await import('@shopify/events');CLU=m.CartLinesUpdateEvent;SE=m.StandardEvents}catch(e){}
const HOOFD=65252444111197;
const GIFTS=[65403227570525,65403227603293,65403227636061,65403227668829];
const PER_BEURT={65252444930397:'\u20ac0,50 per scheerbeurt',65252444963165:'\u20ac0,26 per scheerbeurt',65263547449693:'\u20ac0,24 per scheerbeurt'};
async function wagenNu(){return await (await fetch('/cart.js',{headers:{Accept:'application/json'}})).json()}
function meldCart(w,actie){
  if(!CLU)return;
  const d=CLU.createPromise();
  document.dispatchEvent(new CLU({action:actie||'add',context:'product',lines:[],promise:d.promise}));
  d.resolve({cart:CLU.createCartFromAjaxResponse(w),detail:{items:w.items,source:'bs-drawer',itemCount:w.item_count,didError:false}});
  const ic=document.querySelector('cart-icon');
  if(ic&&ic.renderCartBubble)ic.renderCartBubble(w.item_count);
}
async function voegToe(items){
  if(items.some(function(i){return i.id===HOOFD})){
    const w0=await wagenNu();
    const bestaandeOne=w0.items.find(function(i){return i.variant_id===HOOFD});
    if(bestaandeOne){
      await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:bestaandeOne.key,quantity:bestaandeOne.quantity+items.filter(function(i){return i.id===HOOFD}).reduce(function(s,i){return s+(i.quantity||1)},0)})});
      items=items.filter(function(i){return i.id!==HOOFD});
      if(!items.length){const w1=await wagenNu();meldCart(w1,'update');const la1=document.querySelector('theme-drawer#cart-drawer');if(la1&&typeof la1.open==='function'&&!la1.hasAttribute('open'))la1.open();return}
    }
    const aanwezig=new Set(w0.items.map(function(i){return i.variant_id}));
    const cadeaus=GIFTS.filter(function(g){return !aanwezig.has(g)}).map(function(g){return{id:g,quantity:1,properties:{'Cadeau':'Gratis bij BaldState One'}}});
    items=cadeaus.concat(items);
  }
  const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
  if(!r.ok)throw new Error('mislukt');
  const w=await wagenNu();
  meldCart(w,'add');
  const la=document.querySelector('theme-drawer#cart-drawer');
  if(la&&typeof la.open==='function'&&!la.hasAttribute('open'))la.open();
}
let bewakerBezig=false,bewakerTimer=null;
function planCheck(ms){clearTimeout(bewakerTimer);bewakerTimer=setTimeout(bewaakGifts,ms||400)}
async function bewaakGifts(){
  if(bewakerBezig){planCheck(800);return}
  bewakerBezig=true;
  try{
    const w=await wagenNu();
    const heeftHoofd=w.items.some(function(i){return i.variant_id===HOOFD});
    const cadeaus=w.items.filter(function(i){return GIFTS.indexOf(i.variant_id)>=0});
    if(!heeftHoofd&&cadeaus.length){
      const updates={};cadeaus.forEach(function(i){updates[i.key]=0});
      await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:updates})});
      const w2=await wagenNu();
      meldCart(w2,'remove');
    }else if(heeftHoofd){
      const doel=w.items.filter(function(i){return i.variant_id===HOOFD}).reduce(function(s,i){return s+i.quantity},0);
      const updates={};let teveel=false;
      cadeaus.forEach(function(i){if(i.quantity!==doel){updates[i.key]=doel;teveel=true}});
      const aanwezig=new Set(cadeaus.map(function(i){return i.variant_id}));
      const ontbreekt=GIFTS.filter(function(g){return !aanwezig.has(g)});
      if(teveel){
        await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:updates})});
      }
      if(ontbreekt.length){
        await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:ontbreekt.map(function(g){return{id:g,quantity:doel,properties:{'Cadeau':'Gratis bij BaldState One'}}})})});
      }
      if(teveel||ontbreekt.length){
        const w2=await wagenNu();
        meldCart(w2,ontbreekt.length?'add':'update');
      }
    }
  }catch(e){}finally{bewakerBezig=false}
}
if(SE&&SE.cartLinesUpdate){
  document.addEventListener(SE.cartLinesUpdate,function(ev){
    if(ev&&ev.promise&&ev.promise.then){ev.promise.then(function(){planCheck(300)},function(){planCheck(300)})}
    else planCheck(1000);
  });
}
document.addEventListener('click',function(e){
  if(e.target&&e.target.closest&&e.target.closest('theme-drawer#cart-drawer'))planCheck(1600);
},true);
document.addEventListener('submit',function(ev){
  const f=ev.target;
  if(!(f instanceof HTMLFormElement))return;
  if(f.hasAttribute('data-bs-naar-offer'))return;
  if(!(f.getAttribute('action')||'').startsWith('/cart/add'))return;
  if(!f.closest('.bsm,.bsx,.bsfm,.bsfx'))return;
  const fd=new FormData(f);
  const id=parseInt(fd.get('id'),10);
  if(!id)return;
  ev.preventDefault();
  const items=[{id:id,quantity:parseInt(fd.get('quantity'),10)||1}];
  if(f.hasAttribute('data-bs-hoofd')){
    const wrap=f.closest('.bsm')||f.closest('.bsx');
    const kb=wrap&&wrap.querySelector('input[data-bs-extra]');
    if(kb&&kb.checked)items.push({id:parseInt(kb.getAttribute('data-bs-extra'),10),quantity:1});
  }
  voegToe(items).catch(function(){f.submit()});
},true);
const KOPPEN_IDS=[65252444963165,65263547449693];
const KOPPEN_THUMB='https://cdn.shopify.com/s/files/1/1012/4030/8061/files/bs7-kit-scheerkoppen-sq-v2.webp?v=1786408076';
function eur(c){return '\u20ac'+(c/100).toFixed(2).replace('.',',');}
async function verfraaiCart(){
  const dr=document.querySelector('theme-drawer#cart-drawer');
  if(!dr)return;
  let w=null;try{w=await wagenNu()}catch(e){return}
  // 1. titel: "Winkelwagen · N artikelen"
  const titel=dr.querySelector('.theme-drawer__title');
  if(titel){
    let n=titel.querySelector('.bs-cart-n');
    if(!n){titel.childNodes.forEach(function(k){if(k.nodeType===3)k.textContent=''});
      const badge=titel.querySelector('.theme-drawer__badge');if(badge)badge.style.display='none';
      const lbl=document.createElement('span');lbl.className='bs-cart-lbl';lbl.textContent='Winkelwagen';
      n=document.createElement('span');n.className='bs-cart-n';
      titel.prepend(lbl);titel.appendChild(n);}
    n.textContent='\u00b7 '+w.item_count+' '+(w.item_count===1?'artikel':'artikelen');
  }
  // 2. besparings-badge in de One-rij
  const one=w.items.find(function(i){return i.variant_id===HOOFD});
  const oneRij=dr.querySelector('tr[data-key^="'+HOOFD+'"]')||dr.querySelector('tr[id^="CartItem-'+HOOFD+'"]');
  if(one&&oneRij&&!oneRij.querySelector('.bs-bespaar')){
    const b=document.createElement('span');b.className='bs-bespaar';
    const besparing=(one.original_price>one.final_price?one.original_price-one.final_price:3900);
    b.textContent='Je bespaart '+eur(besparing);
    const det=oneRij.querySelector('.cart-items__details');
    const strike=det?det.querySelector('s'):null;
    if(strike&&strike.parentElement)strike.parentElement.appendChild(b);
    else if(det)det.appendChild(b);
  }
  // gift-rijen: markeren, property-regel netjes, prijs 'Gratis'
  w.items.forEach(function(it){
    if(GIFTS.indexOf(it.variant_id)<0)return;
    const rij=dr.querySelector('tr[data-key^="'+it.variant_id+'"]')||dr.querySelector('tr[id^="CartItem-'+it.variant_id+'"]');
    if(!rij)return;
    rij.classList.add('bs-gift');
    [...rij.querySelectorAll('li,dd,span,div,p,dl')].forEach(function(li){
      if(li.children.length>2)return;
      if(/^Cadeau:\s*Gratis bij/i.test((li.textContent||'').trim())&&(li.textContent||'').length<60){li.innerHTML='Cadeau bij BaldState One';li.classList.add('bs-cadeau');return}
      const tx=(li.textContent||'').trim();
      if(/^Cadeau:/i.test(tx)){li.textContent='Cadeau bij BaldState One';li.classList.add('bs-cadeau')}
      else if(/4 gratis extra/i.test(tx)){li.style.display='none'}
      else if(/^\u20ac0,00/.test(tx)){var ouder=li.closest('div');if(ouder&&ouder.querySelector('s'))ouder.style.display='none';else li.style.display='none'}
    });
    const tot=rij.querySelector('.cart-items__totals')||rij.querySelector('td[headers=productTotal]');
    if(tot){const oudeWas=tot.querySelector('.bs-gratis-was');if(oudeWas&&oudeWas.textContent!==eur(it.original_line_price))oudeWas.textContent=eur(it.original_line_price);}
    if(tot&&!tot.querySelector('.bs-gratis')){
      [...tot.querySelectorAll('*')].forEach(function(e){if(e.children.length===0&&/0,00/.test(e.textContent||''))e.style.display='none'});
      const g=document.createElement('div');g.className='bs-gratis';g.textContent='Gratis';tot.prepend(g);
      if(it.original_line_price>0){const s=document.createElement('div');s.className='bs-gratis-was';s.textContent=eur(it.original_line_price);tot.appendChild(s);}
    }
  });
  // 2c. design-thumbs, label-opruiming, One-regels visueel samenvoegen
  w.items.forEach(function(it){
    const rij=dr.querySelector('tr[data-key^="'+it.variant_id+'"]');
    if(!rij)return;
    if(it.variant_id!==HOOFD){[...rij.querySelectorAll('li')].forEach(function(li){if(/gratis extra/i.test(li.textContent||''))li.style.display='none'})}
    if(KOPPEN_IDS.indexOf(it.variant_id)>=0){
      const tl=rij.querySelector('.cart-items__title');if(tl&&tl.textContent!=='3 scheerkoppen')tl.textContent='3 scheerkoppen';
      [...rij.querySelectorAll('dd,li,span,div')].forEach(function(e){
        if(e.children.length>0)return;const tx=(e.textContent||'').trim();
        if(tx==='3 koppen')e.textContent='Tot zo\u2019n 150 scheerbeurten';
        else if(/^Per beurt/i.test(tx))e.style.display='none';
      });
    }
  });
  const oneLijnen=w.items.filter(function(i){return i.variant_id===HOOFD});
  const oneRijen=[...dr.querySelectorAll('tr[data-key^="'+HOOFD+'"]')];
  if(oneLijnen.length>1&&oneRijen.length>1){
    const som=oneLijnen.reduce(function(s,i){return s+i.quantity},0);
    const prijsSom=oneLijnen.reduce(function(s,i){return s+i.final_line_price},0);
    oneRijen.slice(1).forEach(function(r){r.style.display='none'});
    const inp=oneRijen[0].querySelector('input[name="updates[]"]');
    if(inp&&inp.value!=String(som))inp.value=som;
    const pb=oneRijen[0].querySelector('button[aria-label*=erwijder], a[aria-label*=erwijder], button[name=minus] ~ * button');
    const trash=[...oneRijen[0].querySelectorAll('button,a')].find(function(b){return /verwijder|remove/i.test((b.getAttribute('aria-label')||'')+(b.className||''))});
    if(trash&&!trash.dataset.bsAlles){trash.dataset.bsAlles='1';
      trash.addEventListener('click',function(e){e.preventDefault();e.stopImmediatePropagation();
        const upd={};oneLijnen.forEach(function(i){upd[i.key]=0});
        fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:upd})}).then(function(){return wagenNu()}).then(function(w2){meldCart(w2,'remove')});
      },true);}
    const tot=oneRijen[0].querySelector('.cart-items__totals')||oneRijen[0].querySelector('td[headers=productTotal]');
    if(tot){const leaf=[...tot.querySelectorAll('*')].find(function(e){return e.children.length===0&&/\u20ac/.test(e.textContent||'')});
      if(leaf)leaf.textContent=eur(prijsSom);}
  }
  // 2a. totaal in de Afrekenen-knop
  const bt=dr.querySelector('.cart__checkout-button .button-text');
  if(bt&&w.item_count>0)bt.textContent='Afrekenen \u00b7 '+eur(w.total_price);
  // 2b. dynamic wallet: 1 knop tegelijk, voorkeur voor wat het apparaat echt ondersteunt (Apple Pay eerst), gecentreerd
  const acc=dr.querySelector('shopify-accelerated-checkout-cart');
  if(acc){
    const kids=[...acc.children].filter(function(k){return k.tagName!=='STYLE'});
    if(kids.length){
      kids.forEach(function(k){k.style.display=''});
      const zicht=kids.filter(function(k){const r=k.getBoundingClientRect();return r.width>10&&r.height>10});
      if(zicht.length){
        const apple=zicht.find(function(k){return /apple/i.test(k.tagName)});
        const keuze=apple||zicht[0];
        zicht.forEach(function(k){if(k!==keuze)k.style.display='none'});
        keuze.style.transform='';
        const ab=acc.getBoundingClientRect(),kb=keuze.getBoundingClientRect();
        const schuif=Math.round((ab.width-kb.width)/2-(kb.left-ab.left));
        if(Math.abs(schuif)>2){keuze.style.transform='translateX('+schuif+'px)'}
      }
    }
  }
  // 3. upsell "Maak je set compleet"
  const heeftKoppen=w.items.some(function(i){return KOPPEN_IDS.indexOf(i.variant_id)>=0});
  let blok=dr.querySelector('#bs-upsell');
  const doelwit=dr.querySelector('.cart-drawer__items');
  if(!heeftHoofdIn(w)||heeftKoppen||w.item_count===0){if(blok)blok.remove();return}
  if(!blok&&doelwit){
    blok=document.createElement('div');blok.id='bs-upsell';
    blok.innerHTML='<div class="bs-upsell-kop">Maak je set compleet</div>'
      +'<div class="bs-upsell-kaart"><img src="'+KOPPEN_THUMB+'" alt="3 verse scheerkoppen" loading="lazy">'
      +'<div class="bs-upsell-tekst"><div class="bs-upsell-titel">3 scheerkoppen</div>'
      +'<div class="bs-upsell-prijs"><b>\u20ac39,00</b></div>'
      +'<div class="bs-upsell-sub">\u20ac0,26 per beurt</div>'
      +'<button type="button" class="bs-upsell-knop">Voeg toe</button></div></div>';
    doelwit.appendChild(blok);
    blok.querySelector('.bs-upsell-knop').addEventListener('click',function(){
      const kn=blok.querySelector('.bs-upsell-knop');kn.disabled=true;kn.textContent='\u2026';
      voegToe([{id:65252444963165,quantity:1}]).then(function(){blok.remove()}).catch(function(){kn.disabled=false;kn.textContent='Voeg toe'});
    });
  }
}
function heeftHoofdIn(w){return w.items.some(function(i){return i.variant_id===HOOFD})}
setInterval(function(){const d=document.querySelector('theme-drawer#cart-drawer[open]');if(d)verfraaiCart()},900);
document.addEventListener('click',function(){setTimeout(verfraaiCart,900)},true);
}
